module.exports = __webpack_public_path__ + "img/f7da0cc10fee163da25c74b7b0c98978.jpg";